import React from "react";
import { Link } from "react-router-dom";
import Insta from "../../../assets/Group.svg";
import linkedIn from "../../../assets/linkedInBlack.svg";
import facebook from "../../../assets/facebookBlack.svg";
import youtube from "../../../assets/youtubeBlack.svg";
import rocket from "../../../assets/rocket.svg";
import noPositionLogo from "../../../assets/Frame 2087324672.svg";

const NoOpening = () => {
  return (
    <div className="w-full lg:mx-auto lg:max-w-7xl mt-12">
      <div className="flex lg:items-start lg:justify-end max-xl:px-6 lg:pb-16 max-lg:flex-col-reverse gap-[32px] sm:gap-10 lg:gap-[90px]">
        <div className="max-w-[600px] flex flex-col gap-8">
          <div className="max-w-[600px]">
            <p className="text-darkPurple uppercase text-sm font-bold mb-3">
              Careers
            </p>
            <h2 className="text-xl sm:text-[32px] lg:text-[40px] font-bold text-darkGray mb-2">
              No Open Positions
            </h2>
            <div className="flex flex-col gap-4 pt-4">
              <p className="text-lg text-darkGray/70 ">
                At RegTechFlow, we are always on the lookout for innovative
                minds who are passionate about corporate, regulatory compliance,
                automation, and the future of RegTech industry.
              </p>
              <p className="text-lg text-darkGray/70">
                While we don’t have any open positions at the moment, we
                encourage you to stay connected! We’re growing fast, and new
                opportunities arise regularly.{" "}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="flex  gap-1 text-darkPurple text-xl font-bold mb-2">
              <img src={rocket} alt="rocket" width={32} height={32} />
              Don’t Miss Out!
            </h3>
            <p className="text-darkGray/80 text-lg">
              Unlock career opportunities, insider updates, and exclusive news.
              Follow us and stay ahead!
            </p>
          </div>
          <div className="flex gap-6 max-lg:mt-4">
            <Link
              to="https://www.linkedin.com/company/regtechflow/"
              className="text-[#1E1E1E]/70 font-medium hover:text-darkPurple"
              target="_blank"
            >
              {" "}
              <img src={linkedIn} alt="insta" width={24} height={24} />
            </Link>
            <Link
              to="https://www.facebook.com/share/1E9RNNJx29/"
              className="text-[#1E1E1E]/70 font-medium hover:text-darkPurple"
              target="_blank"
            >
              {" "}
              <img src={facebook} alt="world" width={24} height={24} />
            </Link>
            <Link
              to="https://www.instagram.com/regtechflow?igsh=ajliZjB3ZHdjamRw"
              className="text-[#1E1E1E]/70 font-medium hover:text-darkPurple"
              target="_blank"
            >
              {" "}
              <img src={Insta} alt="world" width={24} height={24} />
            </Link>
            <Link
              to="https://youtu.be/Uo4vA9u1CNk"
              className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE] mt-[2px]"
              target='_blank'
            >
              {" "}
              <img src={youtube} alt="youtube" width={24} height={24} />
          </Link>
          </div>
        </div>
        <div className="bg-background rounded-lg flex justify-start items-center lg:w-[541px] lg:py-8">
          <img src={noPositionLogo} alt="No-positions" />
        </div>
      </div>
    </div>
  );
};

export default NoOpening;
